export default function carousel() {
	const carouselSlider = document.querySelector('.carousel__slider');
	const list = document.querySelector('.carousel__list');

	if (!list) return;

	let list2;

	const speed = 1;

	const width = list.offsetWidth;
	let x = 0;
	let x2 = width;

	function clone() {
		list2 = list.cloneNode(true);
		carouselSlider.appendChild(list2);
		list2.style.left = `${width}px`;
	}

	function moveFirst() {
		x -= speed;

		if (width >= Math.abs(x)) {
			list.style.left = `${x}px`;
		} else {
			x = width;
		}
	}

	function moveSecond() {
		x2 -= speed;

		if (list2.offsetWidth >= Math.abs(x2)) {
			list2.style.left = `${x2}px`;
		} else {
			x2 = width;
		}
	}

	let a = setInterval(moveFirst, 10);
	let b = setInterval(moveSecond, 10);

	function hover() {
		clearInterval(a);
		clearInterval(b);
	}

	function unhover() {
		a = setInterval(moveFirst, 10);
		b = setInterval(moveSecond, 10);
	}

	clone();

	list.addEventListener('mouseenter', hover);
	list.addEventListener('mouseleave', unhover);
	list2.addEventListener('mouseenter', hover);
	list2.addEventListener('mouseleave', unhover);
}
